import { render, staticRenderFns } from "./VWarningMessage.vue?vue&type=template&id=57b874ed&"
import script from "./VWarningMessage.vue?vue&type=script&lang=js&"
export * from "./VWarningMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports